export default (transferId, lang = 'en') => {
  const url = `${process.env.API_LOCATION}/delivery_notes/warehouse_transfer/${lang}/${transferId}/?token=${localStorage.getItem('id_token')}`;
  window.open(url);
};



// WEBPACK FOOTER //
// ./src/app/services/transfer/showDeliveryNote.js